export default __webpack_public_path__ + "static/media/PSPVWaterQuantTemplate.453f5a40.xlsx";